import { ArrowLeft } from 'lucide-react';
import { Link, useNavigate, useParams } from 'react-router-dom';

import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';
import { WorkItemForm } from '../components/WorkItemDetailDrawer';
import { useProject, useWorkItem } from '../queries';

/** Full-page view of a single work item (the canonical link target). Reuses the
 *  same editable form as the side drawer. */
export function WorkItemDetailPage() {
  const { publicId = '', itemPublicId = '' } = useParams();
  const navigate = useNavigate();
  const projectQuery = useProject(publicId);
  const itemQuery = useWorkItem(itemPublicId);

  const project = projectQuery.data;
  const item = itemQuery.data;
  const backToProject = () => navigate(`/projects/${publicId}`);

  return (
    <div className="mx-auto max-w-6xl space-y-4">
      <div className="flex items-center gap-2">
        <Button asChild variant="ghost" size="sm" className="-ml-2 text-muted-foreground">
          <Link to={`/projects/${publicId}`}>
            <ArrowLeft className="size-4" /> Back to project
          </Link>
        </Button>
      </div>

      {projectQuery.isPending || itemQuery.isPending ? (
        <div className="space-y-4">
          <Skeleton className="h-6 w-40" />
          <Skeleton className="h-64 w-full" />
        </div>
      ) : !project || !item ? (
        <div className="rounded-md border border-dashed p-10 text-center">
          <p className="font-medium">Work item not found</p>
          <p className="text-muted-foreground text-sm">
            It may have been deleted, or you don’t have access.
          </p>
        </div>
      ) : (
        <WorkItemForm
          key={item.id}
          project={project}
          item={item}
          onClose={backToProject}
          layout="page"
        />
      )}
    </div>
  );
}
